import { toast } from "react-toastify";

const useToast = () => {
  const showToast = (props) => {
    
    const options = {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...props?.opts,
    };

    switch (props?.type) {
      case 1:
        console.log("success");  
        toast.success(props?.message, options);
        break;
      case 2:
        toast.error(props?.message, options);
        break;
      default:
        toast.info(props?.message, options);
        break;
    }
  };

  return { showToast };
};

export default useToast;
